import React from "react"
import { connect } from "react-redux"
import {Tooltip} from "@material-ui/core";
import {Button} from "react-bootstrap";
import translations from "../../../translations";

import {clearProductSelectionsDispatchAction} from "../../../state/product/dispatchActions";
import {ProductImageStacType} from "../../../types/product";
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";

interface PropsType {
  selectedProducts: ProductImageStacType[],
  clearProductSelectionsDispatchActionHandler: any,
  language: string
}

const ClearProductSelectionsButton = (props: PropsType) => {
  const {
    selectedProducts,
    clearProductSelectionsDispatchActionHandler,
    language
  } = props;

  return (
    <div>
      {selectedProducts.length > 0 && (
        <Tooltip
          {...DEFAULT_TOOLTIP_PROPS}
          title={translations("removeAllSelectionsResults", language)}
          placement="top"
        >
          <span>
            <Button
              className="btn clear-results-btn"
              type="submit"
              onClick={clearProductSelectionsDispatchActionHandler}
            >
              {translations("clearSelectionsResults", language)}
            </Button>
          </span>
        </Tooltip>
      )}
    </div>
  )
};

const mapStateToProps = (state) => ({
  selectedProducts: state.product.selectedProducts,
  language: state.application.appParameters.language
});

const mapDispatchToProps = (dispatch) => ({
  clearProductSelectionsDispatchActionHandler: () => dispatch(clearProductSelectionsDispatchAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClearProductSelectionsButton);
